// Đổi mã lỗi STAR_* của backend sang câu tiếng Việt (mẫu: leave-request-error.ts).
// Interceptor axios ném `error.response.data` nên `err` = { statusCode, message, error? };
// `message` có thể là chuỗi hoặc mảng (class-validator).

const STAR_ERROR_MESSAGES: Record<string, string> = {
  STAR_ACCOUNT_FROZEN: 'Tài khoản Sao đang bị khoá.',
  STAR_NOT_PARTICIPANT: 'Người này chưa được gán nhóm Sao.',
  STAR_INSUFFICIENT: 'Số dư Sao không đủ.',
  STAR_ITEM_UNAVAILABLE: 'Món này không còn mở đổi.',
  STAR_OUT_OF_STOCK: 'Món này đã hết hàng.',
  STAR_LIMIT_DAILY: 'Đã vượt giới hạn đổi trong ngày.',
  STAR_LIMIT_MONTHLY: 'Đã vượt giới hạn đổi trong tháng.',
  STAR_CARD_INVALID: 'Thẻ không hợp lệ hoặc đã dùng.',
  STAR_TRANSFER_SELF: 'Không thể tự tặng Sao cho chính mình.',
  STAR_TRANSFER_CAP: 'Vượt trần tặng/nhận Sao trong tháng.',
  STAR_TRANSFER_MAX: 'Số Sao tặng vượt mức tối đa của thẻ.',
  STAR_TRANSFER_RECENT_PAIR: 'Hai người này vừa tặng nhau trong 30 ngày.',
  STAR_TRANSFER_MESSAGE_REQUIRED: 'Cần có lời nhắn khi tặng Sao.',
  STAR_PENALTY_NOT_OPEN: 'Bản ghi phạt không còn ở trạng thái phù hợp.',
  STAR_ORDER_NOT_PENDING: 'Đơn này đã được xử lý trước đó.',
  STAR_ORDER_CODE_MISMATCH: 'Mã nhận hàng không khớp với đơn này.',
  STAR_REVIEW_SELF: 'Không thể tự xử lý đơn của chính mình — người khác giao.',
  STAR_MISSION_NOT_CLAIMABLE: 'Nhiệm vụ này không nhận báo cáo.',
  STAR_ALREADY_SUBMITTED: 'Đã nộp báo cáo cho kỳ này.',
  STAR_ADJUST_SELF: 'Không thể tự cộng/trừ Sao cho chính mình.',
  STAR_ADJUST_CAP: 'Vượt mức điều chỉnh cho phép mỗi lần (MOD bị giới hạn theo cấu hình).',
  STAR_REASON_REQUIRED: 'Vui lòng nhập lý do.',
  STAR_IDEMPOTENCY_CONFLICT: 'Yêu cầu trùng khoá nhưng khác nội dung.',
  STAR_KC_SELF: 'Không thể nhập KC cho chính mình.',
  STAR_REVIEW_NOT_PENDING: 'Báo cáo này đã được xử lý trước đó.',
  STAR_MISSION_SYSTEM_LOCKED:
    'Nhiệm vụ hệ thống chỉ cho phép sửa tiêu đề, mô tả, thứ tự và trạng thái.',
  STAR_ALREADY_REVERSED: 'Giao dịch này đã được hoàn trước đó.',
  STAR_KC_NO_UID: 'Người này chưa có TikTok UID trong hồ sơ.',
  STAR_INVALID_DATE: 'Ngày không hợp lệ (YYYY-MM-DD).',
  STAR_INVALID_MONTH: 'Tháng không hợp lệ (YYYY-MM).',
  STAR_INVALID_PERIOD_KEY: 'Khoá kỳ không hợp lệ (VD: W2026-39, M2026-09).',
  STAR_AMOUNT_INVALID: 'Số Sao không hợp lệ.',
  STAR_MISSION_CODE_EXISTS: 'Mã nhiệm vụ đã tồn tại.',
  STAR_MISSION_NOT_FOUND: 'Nhiệm vụ không tồn tại.',
  STAR_ITEM_NOT_FOUND: 'Món quà không tồn tại.',
  STAR_ORDER_NOT_FOUND: 'Đơn đổi quà không tồn tại.',
  STAR_PENALTY_NOT_FOUND: 'Bản ghi phạt không tồn tại.',
  STAR_PENALTY_TYPE_NOT_FOUND: 'Loại phạt không tồn tại.',
  STAR_PENALTY_TYPE_INACTIVE: 'Loại phạt đã bị tắt.',
  STAR_PENALTY_SELF: 'Không thể ghi phạt cho chính mình.',
  STAR_USER_NOT_FOUND: 'Người dùng không tồn tại.',
  STAR_ACCOUNT_NOT_FOUND: 'Người này chưa có tài khoản Sao.',
  STAR_KC_DATE_INVALID: 'Ngày KC không hợp lệ.',
  STAR_NO_TIKTOK_UID: 'Người này chưa có TikTok UID.',
  // Quyền theo cấp (Admin / Quản lý tổng (SMOD) / Quản lý vận hành).
  STAR_ACCOUNT_STATUS_ADMIN_ONLY: 'Chỉ Admin khoá hoặc mở ví Sao.',
  STAR_PENALTY_REFUND_ADMIN_ONLY: 'Huỷ lần phạt đã trừ Sao (có hoàn Sao) chỉ Admin làm được.',
  STAR_ACCOUNT_PATCH_SELF: 'Không thể tự sửa ví Sao của chính mình.',
  STAR_ACCOUNT_GROUP_CROSS:
    'Chỉ Admin chuyển ví giữa nhóm Nhân viên và nhóm Creator / Creator NPC.',
  // Tuyển dụng (HR), chấm điểm nhảy, nhiệm vụ mẫu — SPEC-NHIEM-VU-MO-RONG.md §7.
  STAR_RECRUIT_NOT_FOUND: 'Không tìm thấy phiếu tuyển dụng.',
  STAR_RECRUIT_CREATOR_INVALID:
    'Người được chọn không phải Creator Studio (Creator Dance / Creator NPC).',
  STAR_RECRUIT_RECRUITER_INVALID:
    'Người tuyển phải là Nhân viên đang hoạt động và không trùng với Creator.',
  STAR_RECRUIT_DUPLICATE: 'Creator này đã có phiếu tuyển dụng đang hiệu lực.',
  STAR_RECRUIT_NOT_TRACKING: 'Phiếu này không còn ở trạng thái đang theo dõi.',
  STAR_RECRUIT_NOTE_REQUIRED: 'Vui lòng ghi lý do (ít nhất 5 ký tự).',
  STAR_DANCE_NOT_TEACHER: 'Chỉ giáo viên nhảy (hoặc Admin / Quản lý tổng) được chấm điểm.',
  STAR_DANCE_SCORE_INVALID: 'Điểm không hợp lệ: thang 0–10, bước 0,5; người vắng không có điểm.',
  STAR_DANCE_NOT_FOUND: 'Không tìm thấy buổi chấm điểm.',
  STAR_DANCE_EDIT_CLOSED: 'Đã hết hạn sửa buổi này.',
  STAR_DANCE_ALREADY_CANCELLED: 'Buổi này đã bị huỷ trước đó.',
  STAR_TEMPLATE_UNKNOWN:
    'Có mẫu nhiệm vụ không tồn tại (danh sách mẫu đã thay đổi — tải lại trang).',
};

/**
 * Mã mà câu của máy chủ rõ hơn câu cố định (vd. có con số trần thưởng, hay "tạo" khác "sửa"): dùng
 * câu máy chủ gửi ở `error`, câu dưới đây chỉ dùng khi máy chủ không gửi kèm.
 */
const STAR_SERVER_TEXT_FIRST: Record<string, string> = {
  STAR_MISSION_REWARD_CAP: 'Số Sao thưởng vượt mức tối đa cho phép.',
  // Máy chủ gửi câu "tạo" khi tạo mới, câu "sửa" khi sửa / đổi trạng thái nhiệm vụ tự trả thưởng.
  STAR_MISSION_AUTO_PAY_ADMIN_ONLY:
    'Chỉ Admin tạo hoặc sửa được nhiệm vụ tự trả thưởng (không cần duyệt).',
  // Máy chủ nói rõ nhóm/mốc nào sai (vd. "Mốc thâm niên phải tăng dần").
  STAR_CONFIG_INVALID: 'Cấu hình không hợp lệ.',
  // Máy chủ nêu tên người / hạn ngày / mốc cụ thể.
  STAR_RECRUIT_DATE_INVALID:
    'Ngày bắt đầu không hợp lệ: không ở tương lai và không quá 30 ngày trước hôm nay.',
  STAR_RECRUIT_MILESTONE_INVALID: 'Mốc này không xác nhận tay được lúc này.',
  STAR_DANCE_LEARNER_INVALID: 'Có học viên không phải Creator Dance đang hoạt động.',
  STAR_DANCE_DATE_INVALID: 'Ngày buổi không hợp lệ (không ở tương lai, chấm lùi tối đa 2 ngày).',
  STAR_DANCE_EDIT_INSUFFICIENT:
    'Có học viên không đủ Sao để thu hồi phần chênh — lần sửa đã bị huỷ, chưa có gì thay đổi.',
  // Giới hạn chống spam nhiệm vụ nộp tay (409) — docs/nghien-cuu-diem-sao/10 §6.3. Máy chủ gửi
  // câu có số cụ thể ở `error` ("Hôm nay đã gửi 3/3 báo cáo."); câu dưới chỉ là dự phòng.
  // Tên mã không được là chuỗi con của nhau (tra bằng includes): DAY_CAP ≠ PERSON_DAY_CAP — có test.
  STAR_CLAIM_DAY_CAP: 'Nhiệm vụ này hôm nay đã nộp đủ số lần cho phép.',
  STAR_CLAIM_WEEK_CAP: 'Nhiệm vụ này tuần này đã nộp đủ số lần cho phép.',
  STAR_CLAIM_PERSON_DAY_CAP: 'Hôm nay bạn đã gửi đủ số báo cáo nhiệm vụ cho phép.',
  STAR_CLAIM_PENDING_CAP: 'Bạn đang có quá nhiều báo cáo chờ duyệt — chờ duyệt xong rồi gửi tiếp.',
  STAR_CLAIM_REJECT_CAP: 'Báo cáo kỳ này đã bị từ chối quá số lần cho phép, không nộp lại được.',
  STAR_CLAIM_MONTH_CAP:
    'Tháng này bạn đã nhận đủ Sao từ nhiệm vụ nộp tay (tính cả phần đang chờ duyệt).',
  STAR_CLAIM_EVIDENCE_REQUIRED:
    'Cần dán link minh chứng (ảnh, video, Drive, Zalo hoặc TikTok) trước khi gửi báo cáo.',
};

const GENERIC_ERROR =
  /^(Bad Request|Not Found|Conflict|Unprocessable Entity|Forbidden|Unauthorized|Internal Server Error)$/i;
const CODE_LIKE = /^[A-Z][A-Z0-9_]{3,}$/;

function rawMessage(err: any): string | undefined {
  if (Array.isArray(err?.message)) return err.message.join(', ');
  if (typeof err?.message === 'string') return err.message;
  if (typeof err?.error === 'string') return err.error;
  return undefined;
}

export function mapStarError(err: any): string {
  const status: number | undefined = err?.statusCode || err?.status;
  const raw = rawMessage(err);
  // Backend có thể gửi kèm mô tả tiếng Việt ở `error` (bỏ qua chữ chung của HTTP và mã trơn).
  const errorText = typeof err?.error === 'string' ? err.error.trim() : '';
  const description =
    errorText && !GENERIC_ERROR.test(errorText) && !CODE_LIKE.test(errorText) ? errorText : '';

  for (const [code, message] of Object.entries(STAR_SERVER_TEXT_FIRST)) {
    if (raw?.includes(code)) return description || message;
  }
  for (const [code, message] of Object.entries(STAR_ERROR_MESSAGES)) {
    if (raw?.includes(code)) return message;
  }
  // Mã chưa có trong bảng: câu tiếng Việt máy chủ gửi kèm vẫn dễ hiểu hơn mã trơn.
  if (description) return description;
  if (raw?.startsWith('STAR_')) return `Lỗi ${raw}.`;

  if (raw === 'Forbidden' || status === 403) return 'Bạn không có quyền thực hiện thao tác này.';
  if (raw === 'Unauthorized' || status === 401) return 'Phiên đăng nhập đã hết hạn.';
  if (status === 404)
    return 'Không tìm thấy dữ liệu (API Điểm Sao chưa sẵn sàng hoặc bản ghi đã bị xoá).';
  if (status && status >= 500) return 'Lỗi server. Vui lòng thử lại sau.';
  if (
    typeof err?.message === 'string' &&
    /Cannot read properties|Network Error/.test(err.message)
  ) {
    return 'Mất kết nối tới server.';
  }
  return raw || 'Có lỗi xảy ra. Vui lòng thử lại.';
}

export function hasStarErrorCode(err: any, code: string): boolean {
  return !!rawMessage(err)?.includes(code);
}
